

















































































































































































































































































































































































































































































































import { State, Getter, Action } from 'vuex-class';
import { Component, Vue, Watch } from 'vue-property-decorator';
import { Drag, Drop, DropList } from 'vue-easy-dnd';
import { SortOrder } from '@/enums/SortOrder';
import { default as VSelect } from 'vue-select';
import { OptionType } from '@/enums/OptionType';
import { Locale } from '@/enums/Locale';
import { BulkAction } from '@/enums/BulkAction';

// @ts-ignore
@Component({
  components: {
    PagePresetDashboard: () => import('@/layouts/presets/dashboard.vue'),
    PartBox: () => import('@/layouts/parts/box.vue'),
    PartOverlay: () => import('@/layouts/parts/overlay.vue'),
    PartTabs: () => import('@/layouts/parts/tabs.vue'),
    // Form elements
    FormBase: () => import('@/components/forms/Base.vue'),
    FormInput: () => import('@/components/forms/Input.vue'),
    FormCheckbox: () => import('@/components/forms/Checkbox.vue'),
    FormBadgeSelect: () => import('@/components/forms/BadgeSelect.vue'),
    FormWysiwyg: () => import('@/components/forms/Wysiwyg.vue'),
    FormButton: () => import('@/components/forms/Button.vue'),
    FormImageUpload: () => import('@/components/forms/ImageUpload.vue'),
    FormSearchCollections: () => import('@/components/forms/SearchCollections.vue'),
    ServerError: () => import('@/components/forms/ServerError.vue'),
    LanguageSelector: () => import('@/components/parts/LanguageSelector.vue'),
    Drag,
    Drop,
    DropList,
    VSelect,
  },
})
export default class PageProductsShow extends Vue {
  @Getter('product/viewing') product!: Product;

  @Getter('workspace/selected') workspace!: Workspace;

  @Getter('collect/all') collects!: Collect[];

  @Action('collection/read') readCollection!: (payload: { id: number; workspaceId: number }) => Promise<Collection>;

  @Action('collection/index') indexCollection!: (payload: { query?: IndexQuery<Collection & { products: number[] }>; workspaceId: number }) => Promise<Collection[]>;

  @Action('product/create') createProduct!: (payload: { product: Product; workspaceId: number }) => Promise<Product>;

  @Action('product/externalProducts') externalProducts!: (payload: { query?: { after?: Array<number | string>; ids?: number[] }; workspaceId: number }) => Promise<Product>;

  @Action('product/read') readProduct!: (payload: { id: number; workspaceId: number }) => Promise<Product>;

  @Action('product/update') updateProduct!: (payload: { product: Product; workspaceId: number }) => Promise<Product>;

  @Action('product/delete') deleteProduct!: (payload: { id: number; workspaceId: number }) => Promise<Product>;

  @Action('option/index') indexOptions!: (payload: { query?: IndexQuery<Option>; workspaceId: number }) => Promise<{ data: Option[]; total: number }>;

  @Action('option/create') createOption!: ({ data, workspaceId }: { data: OptionCreateData; workspaceId: number }) => Promise<Option>;

  @Action('product-translation/index') indexProductTranslations!: (payload: { query?: IndexQuery<ProductTranslation>; workspaceId: number }) => Promise<{ data: ProductTranslation[]; total: number }>;

  @Action('product-translation/create') createProductTranslation!: ({ data, workspaceId }: { data: ProductTranslationData; workspaceId: number }) => Promise<ProductTranslation>;

  @Action('product-translation/update') updateProductTranslation!: ({ id, data, workspaceId }: { id: number; data: ProductTranslationData; workspaceId: number }) => Promise<ProductTranslation>;

  @Action('collect/bulk') bulkCollect!: (payload: { data: CollectBulkData; workspaceId: number }) => Promise<Collect>;

  i18n: string = 'views.products.show';

  $refs!: Vue['$refs'] & {
    productForm: FormClass;
    volumeDiscount: FormClass;
    deleteForm: FormClass;
    optionCreate: FormClass;
  };

  payload: ProductData = {
    name: '',
    slug: '',
    description: '',
    introduction: '',
    is_top: false,
    options: [],
    variants: [],
    media: [],
    status: 'draft',
    collections: [],
    volume_discounts: [{ from: 1, discount: 1.5 }],
  };

  addingOption = false;

  optionPayload: OptionCreateData = {
    key: '',
    type: OptionType.STRING,
    name: '',
    template: null,
    filterable: true,
    ordinal: 0,
  };

  productTranslationPayload: ProductTranslationData = {
    locale: Locale.NL_BE,
    name: '',
    introduction: '',
    description: '',
    product_id: 0,
    variants: [],
  };

  selectedCollectionIds: number[] = this.$store.getters['collect/all'].map((collect: Collect) => collect.collection_id);

  options: Option[] = [];

  defaultOptions: Option[] = [];

  searchedOptions: Option[] = [];

  totalSearchOptions: number = 0;

  initialSearched: boolean = false;

  videos: ProductImage[] = [{ name: '', path: '', external: true, type: 'youtube', order: 0 }];

  collections: Collection[] = [];

  AllCollections: Collection[] = [];

  formLoaded: boolean = false;

  popupEditOptions: boolean = false;

  popupVolumeDiscounts: boolean = false;

  popupBulkVariantsOptions: boolean = false;

  popupVariantStepLoading: boolean = false;

  popupVariantStepSuccess: boolean = false;

  popupDeleteProduct: boolean = false;

  variants: string = '';

  optionSearchString = '';

  optionsObserver: IntersectionObserver | null = null;

  optionValue: any = null;

  selectedLanguage: Locale = process.env.VUE_APP_DEFAULT_LOCALE;

  productTranslationId?: number = undefined;

  externalFieldMappings: { [key: string]: (variant: any) => any } = {
    size: (variant: any) => `${variant.content.length}x${variant.content.width}`,
  };

  created() {
    this.loadSelectedProductData();
  }

  mounted() {
    // @ts-ignore
    this.optionsObserver = new IntersectionObserver(this.infiniteScroll);
  }

  loadSelectedProductData() {
    if (!this.product) {
      return;
    }
    this.indexOptions({
      workspaceId: this.workspace.id,
      query: {
        q: { or: { id: this.product.options.map((option) => option.id) } },
        per_page: this.product.options.length,
        s: { ordinal: SortOrder.ASC, created_at: SortOrder.DESC, id: SortOrder.ASC },
      },
    }).then((response) => {
      this.options = [...response.data];
    });

    if (this.product.collections_total === 0) {
      return;
    }
    this.indexCollection({
      workspaceId: this.workspace.id,
      query: {
        q: { products: this.product.id },
        per_page: this.product.collections_total,
        s: { created_at: SortOrder.DESC, id: SortOrder.ASC },
      },
    }).then((collections) => {
      this.collections = collections;
    });
  }

  addOptionRow() {
    this.addingOption = true;
  }

  cancelOptionCreate() {
    this.addingOption = false;
    this.optionPayload.key = '';
    this.optionPayload.name = '';
    this.optionPayload.filterable = true;
    this.optionPayload.type = OptionType.STRING;
  }

  addVolumeDiscount() {
    this.payload.volume_discounts.push({ from: 1, discount: 1.5 });
  }

  insertOptions(event: any) {
    this.payload.options.splice(event.index, 0, event.data);
  }

  removeOption(options: any, option: any) {
    const index = options.indexOf(option);
    options.splice(index, 1);

    this.inputVariants.forEach((iv: any) => {
      delete iv.content[option.key];
    });
  }

  bulkAddVariants() {
    const variants: Array<number | string> = [...new Set(this.variants.split(','))];
    this.popupVariantStepLoading = true;
    // @ts-ignore
    this.externalProducts({ query: { ids: variants }, workspaceId: this.workspace.id })
      .then(async (result: any) => {
        this.variants = '';
        await this.generateVariants(result);
        this.popupVariantStepSuccess = true;
        this.popupBulkVariantsOptions = false;
      })
      .finally(() => {
        this.popupVariantStepLoading = false;
      });
  }

  async generateVariants(variants: any) {
    await this.getDefaultOptions();
    variants.forEach((variant: any) => {
      const productVariant: ProductVariantData = {
        external_id: variant.id,
        original_price: variant.original_price,
        status: 'published',
        stock: variant.stock,
        stock_block: 0,
        min_order_amount: 0,
        min_invoice_amount: 0,
        min_offer_amount: null,
        content: {},
      };

      this.defaultOptions.forEach((defaultOption) => {
        this.maybeAddOption(defaultOption.key);
        if (this.externalFieldMappings[defaultOption.key] !== undefined) {
          productVariant.content[defaultOption.key] = this.externalFieldMappings[defaultOption.key](variant);
          return;
        }
        if (variant.content[defaultOption.key] && variant.content[defaultOption.key] !== '0') {
          productVariant.content[defaultOption.key] = variant.content[defaultOption.key];
          return;
        }
        productVariant.content[defaultOption.key] = defaultOption.type === OptionType.BOOLEAN ? false : null;
      });

      this.payload.variants.push(productVariant);
    });
  }

  maybeAddOption(key: string): void {
    const match = this.defaultOptions.find((option) => option.key === key);
    if (!match) {
      return;
    }

    if (!this.options.find((option) => option.key === match.key)) {
      this.options.push(match);
    }

    this.payload.variants.forEach((variant) => {
      if (!variant.content.hasOwnProperty(key)) {
        variant.content[key] = '';
      }
    });
  }

  addVariantRow() {
    const option: ProductVariantData = {
      external_id: '',
      status: 'published',
      original_price: 0,
      stock: 0,
      stock_block: 0,
      min_order_amount: 0,
      min_invoice_amount: 0,
      min_offer_amount: null,
      content: {},
    };
    this.payload.variants.push(option);
  }

  productMediaUpdated(media: Array<{ default: number; highlight: number; name: string; path: string }>) {
    // @ts-ignore
    this.payload.media = media.map((file: { id?: number; default: number; highlight: number; name: string; path: string }, i: number) => {
      return {
        id: file.id,
        order: i + 1,
        path: file.path,
        name: file.name,
      };
    });
  }

  getTemplateValue(template: string, content: { [key: string]: any }): string {
    const matches = [...template.matchAll(/\{[a-z_]*\}/g)].flat();
    let generatedTemplate = template;
    for (const match of matches) {
      const key = match.replace('{', '').replace('}', '');
      const value = content[key] ?? match;
      generatedTemplate = generatedTemplate.replace(match, value);
    }

    return generatedTemplate;
  }

  get productMedia() {
    return this.payload.media
      .filter((media: ProductImage) => !media.external)
      .sort((a: ProductImage, b: ProductImage) => a.order - b.order)
      .map((media: ProductImage) => {
        return {
          id: media.id,
          path: media.path,
          name: media.name,
          default: media.order === 1 ? 1 : 0,
          highlight: media.order === 1 ? 1 : 0,
        };
      });
  }

  get productUrl() {
    const websiteUrl = this.workspace.config?.website_url ?? process.env.VUE_APP_WEB_URL;
    const locale = this.selectedLanguage.substring(0, 2);
    return `${websiteUrl}/${locale}/product/${this.product.slug}`;
  }

  get hasNextPage() {
    return this.searchedOptions.length < this.totalSearchOptions;
  }

  get defaultLanguageSelected() {
    return process.env.VUE_APP_DEFAULT_LOCALE === this.selectedLanguage;
  }

  get localeDisabledClasses() {
    return { 'pointer-events-none opacity-50': !this.defaultLanguageSelected };
  }

  get inputName(): string {
    if (this.defaultLanguageSelected) {
      return this.payload.name;
    }
    return this.productTranslationPayload.name;
  }

  set inputName(name: string) {
    if (this.defaultLanguageSelected) {
      this.payload.name = name;
    }
    this.productTranslationPayload.name = name;
  }

  get inputIntroduction(): string {
    if (this.defaultLanguageSelected) {
      return this.payload.introduction;
    }
    return this.productTranslationPayload.introduction;
  }

  set inputIntroduction(introduction: string) {
    if (this.defaultLanguageSelected) {
      this.payload.introduction = introduction;
    }
    this.productTranslationPayload.introduction = introduction;
  }

  get inputDescription(): string {
    if (this.defaultLanguageSelected) {
      return this.payload.description;
    }
    return this.productTranslationPayload.description;
  }

  set inputDescription(description: string) {
    if (this.defaultLanguageSelected) {
      this.payload.description = description;
    }
    this.productTranslationPayload.description = description;
  }

  get inputVariants() {
    if (this.defaultLanguageSelected) {
      return this.payload.variants;
    }
    return this.productTranslationPayload.variants;
  }

  set inputVariants(variants: VariantTranslation[] | ProductVariantData[]) {
    if (this.defaultLanguageSelected) {
      this.payload.variants = variants as ProductVariantData[];
    }
    this.productTranslationPayload.variants = variants as VariantTranslation[];
  }

  get submitFunction() {
    if (this.defaultLanguageSelected) {
      return this.handleSubmit;
    }
    return this.handleProductTranslationSubmit;
  }

  async getDefaultOptions() {
    if (this.defaultOptions.length > 0) {
      return this.defaultOptions;
    }
    this.defaultOptions = (
      await this.indexOptions({
        workspaceId: this.workspace.id,
        query: {
          q: {
            or: {
              key: this.workspace.config?.default_options ?? [],
            },
          },
          per_page: this.workspace.config?.default_options?.length ?? 0,
        },
      })
    ).data;
    return this.defaultOptions;
  }

  optionIsNotSelected(option: Option) {
    return this.options.find((selectedOption) => option.id === selectedOption.id) === undefined;
  }

  async onOpen() {
    if (!this.initialSearched || this.hasNextPage) {
      if (!this.initialSearched) {
        this.searchOptions(false);
      }
      this.initialSearched = true;
      await this.$nextTick();
      // @ts-ignore
      this.optionsObserver!.observe(this.$refs.load);
    }
  }
  onClose() {
    this.optionsObserver!.disconnect();
  }

  async infiniteScroll([{ isIntersecting, target }]: [{ isIntersecting: boolean; target: HTMLElement }]) {
    if (isIntersecting) {
      const ul = target.offsetParent!;
      const scrollTop = target.offsetParent!.scrollTop;

      await this.searchOptions(true);
      await this.$nextTick();
      ul.scrollTop = scrollTop;
    }
  }

  addOption(option: Option) {
    this.options.push(option);
    this.inputVariants.forEach((iv: any) => {
      if (option.type === OptionType.BOOLEAN) {
        iv.content[option.key] = false;
        return;
      }
      iv.content[option.key] = null;
    });
  }

  async handleLanguageChange(language: Locale) {
    this.loadSelectedProductData();
    if (process.env.VUE_APP_DEFAULT_LOCALE === language) {
      this.selectedLanguage = language;
      return;
    }

    const translation = await this.indexProductTranslations({
      query: {
        q: {
          and: {
            product_id: this.product.id,
            locale: language,
          },
        },
        per_page: 1,
      },
      workspaceId: this.workspace.id,
    });

    this.productTranslationId = translation?.data[0]?.id;

    // @ts-ignore
    this.productTranslationPayload = {
      ...this.payload,
      ...{
        name: translation?.data[0]?.name ?? this.payload.name,
        description: translation?.data[0]?.description ?? this.payload.description,
        introduction: translation?.data[0]?.introduction ?? this.payload.introduction,
        variants: this.payload.variants.map((variant) => {
          const variantTranslation = translation?.data[0]?.variants?.find((vt) => vt.id === variant.id);
          return {
            ...variant,
            ...(variantTranslation ?? {}),
            content: {
              ...(variant.content ?? {}),
              ...(variantTranslation?.content ?? {}),
            },
          };
        }),
        locale: language,
        product_id: this.product.id,
      },
    };
    this.selectedLanguage = language;
  }

  private fetchCollections(collections: number[]) {
    collections.forEach((id: number) => this.readCollection({ id, workspaceId: this.workspace.id }).then((collection: Collection) => this.collections.push(collection)));
  }

  private readAllCollections() {
    this.indexCollection({ workspaceId: this.workspace.id }).then((collections: Collection[]) => {
      this.AllCollections = collections;
    });
  }

  private handleDelete() {
    if (this.product?.id) {
      this.deleteProduct({ id: this.product.id, workspaceId: this.workspace.id })
        .then(() => {
          this.$refs.deleteForm.handleSuccess();
          this.popupDeleteProduct = false;
          this.$router.push({ name: 'products' });
        })
        .catch((e: ErrorResponse) => this.$refs.deleteForm.handleErrors(e));
    }
  }

  private handleSubmit() {
    let func: string = 'updateProduct';
    if (!this.product?.id) {
      func = 'createProduct';
      this.payload.slug = this.slugify(this.inputName);
    }

    const images = this.payload.media.filter((m: ProductImage) => m.path.trim() !== '' && !m.external);
    const videos = this.videos.filter((m: ProductImage) => m.path.trim() !== '' && m.external);
    this.payload.media = [];
    this.payload.media = [...images, ...videos].map((media: ProductImage, order: number) => {
      return {
        ...media,
        order: order + 1,
      };
    });

    (this.payload.options = this.options.map((option, index) => {
      return {
        id: option.id,
        ordinal: index,
      };
    })),
      // @ts-ignore
      this[func]({ product: this.payload, workspaceId: this.workspace.id })
        .then((product: Product) => {
          const collectCrudItems = this.buildCollectCrud(product, this.selectedCollectionIds);
          if (collectCrudItems.length === 0) {
            this.handleSuccess(product, func);
            return;
          }
          this.bulkCollect({ data: { collects: collectCrudItems }, workspaceId: this.workspace.id }).then(() => {
            this.handleSuccess(product, func);
          });
        })
        .catch((e: ErrorResponse) => this.$refs.productForm.handleErrors(e));
  }

  private handleProductTranslationSubmit() {
    if (this.productTranslationId === undefined) {
      this.createProductTranslation({ data: this.productTranslationPayload, workspaceId: this.workspace.id })
        .then((productTranslation) => {
          this.productTranslationId = productTranslation.id;
          this.$refs.productForm.handleSuccess();
        })
        .catch((e: ErrorResponse) => this.$refs.productForm.handleErrors(e));
      return;
    }
    this.updateProductTranslation({ id: this.productTranslationId, data: this.productTranslationPayload, workspaceId: this.workspace.id })
      .then(() => {
        this.$refs.productForm.handleSuccess();
      })
      .catch((e: ErrorResponse) => this.$refs.productForm.handleErrors(e));
  }

  private handleVolumeDiscountSubmit() {
    this.popupVolumeDiscounts = false;
    this.$refs.volumeDiscount.handleSuccess();
  }

  private handleOptionSubmit() {
    this.createOption({ data: this.optionPayload, workspaceId: this.workspace.id }).then((option) => {
      this.options.push(option);
      this.initialSearched = false;
      this.cancelOptionCreate();
      this.$refs.optionCreate.handleSuccess();
    });
  }

  private slugify(text: string) {
    return text
      ?.toLowerCase()
      ?.replace(/e|é|è|ẽ|ẻ|ẹ|ê|ế|ề|ễ|ể|ệ/gi, 'e')
      ?.replace(/a|á|à|ã|ả|ạ|ă|ắ|ằ|ẵ|ẳ|ặ|â|ấ|ầ|ẫ|ẩ|ậ/gi, 'a')
      ?.replace(/o|ó|ò|õ|ỏ|ọ|ô|ố|ồ|ỗ|ổ|ộ|ơ|ớ|ờ|ỡ|ở|ợ/gi, 'o')
      ?.replace(/u|ú|ù|ũ|ủ|ụ|ư|ứ|ừ|ữ|ử|ự/gi, 'u')
      ?.replace(/đ/gi, 'd')
      ?.replace(/\s*$/g, '')
      ?.replace(/\s+/g, '-');
  }

  @Watch('product', { immediate: true, deep: true })
  private handleProductChanged(val: Product) {
    if (!val) {
      return undefined;
    }

    this.payload = JSON.parse(JSON.stringify(val));
    this.videos = this.payload.media.filter((media: ProductImage) => media.external);
  }

  @Watch('optionSearchString')
  private async handleOptionSearch(searchString: string) {
    this.searchOptions(false);
  }

  @Watch('workspace')
  private workspaceChanged(val: Workspace) {
    this.$router.push({ name: 'products' });
  }

  private async searchOptions(nextPage: boolean) {
    const query: IndexQuery<Option> = {
      s: {
        created_at: SortOrder.DESC,
        id: SortOrder.ASC,
      },
    };

    if (nextPage) {
      query.after = this.searchedOptions[this.searchedOptions.length - 1].sort;
    }

    if (this.optionSearchString !== '') {
      query.q = {
        or: {
          key: `like:*${this.optionSearchString}*`,
          // TODO: match and name search
        },
      };
    }

    const optionsResponse = await this.indexOptions({
      query,
      workspaceId: this.workspace.id,
    });

    this.totalSearchOptions = optionsResponse.total;
    if (query.hasOwnProperty('after')) {
      this.searchedOptions = [...this.searchedOptions, ...optionsResponse.data];
      return;
    }
    this.searchedOptions = optionsResponse.data;
  }

  private buildCollectCrud(product: Product, selectedIds: number[]): CollectBulkItem[] {
    const collectBulkItems: CollectBulkItem[] = [];

    selectedIds.forEach((selectedId, index) => {
      let comparisonCollect: Collect | null = this.collects[index] ?? null;
      if (comparisonCollect !== null && comparisonCollect.collection_id === selectedId && comparisonCollect.ordinal === index) {
        return;
      }

      comparisonCollect = this.collects.find((collect) => collect.collection_id === selectedId) ?? null;

      collectBulkItems.push({
        action: comparisonCollect === null ? BulkAction.CREATE : BulkAction.UPDATE,
        id: comparisonCollect?.id,
        collection_id: selectedId,
        product_id: product.id,
        ordinal: 9999, // try to ensure last
      });
    });

    this.collects.forEach((collect) => {
      const foundSelected = this.selectedCollectionIds.find((collectionId) => collectionId === collect.collection_id);
      if (foundSelected !== undefined) {
        return;
      }
      collectBulkItems.push({
        action: BulkAction.DELETE,
        id: collect.id,
      });
    });

    return collectBulkItems;
  }

  private handleSuccess(product: Product, func: string) {
    this.$refs.productForm.handleSuccess();
    if (func === 'createProduct' && product.id) {
      this.$router.push({ name: 'products-detail', params: { id: `${product.id}` } });
    }
  }
}
